import React from 'react';

import autoBind from 'react-autobind';
import Config from "../Config.jsx";

// import other components within the same project here

import LoginDialog from "../views/LoginDialog.jsx";
import ForgetPasswordDialog from "../views/ForgetPasswordDialog.jsx";
import AgreementDialog from "../views/AgreementDialog.jsx"
import AccountDisabledDialog from '../views/AccountDisabledDialog';
import AccountSubscriptionDialog from '../views/AccountSubscriptionDialog';

import {
  grey,
} from '@material-ui/core/colors'

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      forgetPasswordDialogOpen: false,
      agreementDialogOpen: false,
      loginResult: null,
      latestAgreementVersion: 0,
      agreemenText: "",
      has_read_tac: 0,
      dialogCount: 0,
    };
    autoBind(this);

    this.fetchAgreement();
  }

  fetchAgreement() {
    fetch(Config.AGREEMENT_URL())
      .then((resp)=>{ return resp.text() })
      .then((text)=>{
        let parser = new DOMParser();
        let doc = parser.parseFromString(text, 'text/html');
        let content = doc.querySelector('#content').innerHTML;
        this.setState({ agreemenText: content });
        this.state.agreemenText = content;
      })
      .catch(function (err) {
        console.log("failed to load agreement");
      });
  }

  loginOK(res) {
    this.setState({loginResult: res});
    this.state.loginResult = res;
    this.setState({has_read_tac: parseInt(res['has_read_tac'])});
    this.state.has_read_tac = parseInt(res['has_read_tac']);

    if (res['latest_agreement_version'] != null) {
      let agreement_version = parseInt(res['latest_agreement_version']);
      this.setState({ latestAgreementVersion: agreement_version });
      this.state.latestAgreementVersion = agreement_version;
    }

    var dialogCount = 0;

    // check account disabling here
    if (res['user_disabled'] != null) {
      let account_disable_level = Math.max(parseInt(res['user_disabled']), parseInt(res['school_disabled']));
      if(account_disable_level != 0){
        this.refs.accountDisabledDialog.setState({ open: true });
        this.refs.accountDisabledDialog.state.open = true;
        this.refs.accountDisabledDialog.setState({ account_disable_level: account_disable_level });
        this.refs.accountDisabledDialog.state.account_disable_level = account_disable_level;
        dialogCount += 1;
      }
    }

    // check subscription
    if(res['user_subscription'] != null){
      let account_subscription_status = res['user_subscription']['subscription_status'];
      console.log(res['user_subscription']);

      if(account_subscription_status != 2){
        if(account_subscription_status == 1){
          // in range
          // check if subscription ends soon
          let daysLeft = (Date.parse(res['user_subscription']['date_end']) - Date.parse(res['user_subscription']['date_current']))/1000/60/60/24;
          if(daysLeft <= 30){
            this.refs.AccountSubscriptionDialog.setState({ open: true });
            this.refs.AccountSubscriptionDialog.state.open = true;
            this.refs.AccountSubscriptionDialog.setState({ account_subscription_status: account_subscription_status });
            this.refs.AccountSubscriptionDialog.state.account_subscription_status = account_subscription_status;
            this.refs.AccountSubscriptionDialog.setState({ daysLeft: daysLeft });
            this.refs.AccountSubscriptionDialog.state.daysLeft = daysLeft;
            this.refs.AccountSubscriptionDialog.setState({ date_end: res['user_subscription']['date_end'] });
            this.refs.AccountSubscriptionDialog.state.date_end = res['user_subscription']['date_end'];
            dialogCount += 1;
          }
        }else{
          // not in range
          this.refs.AccountSubscriptionDialog.setState({ open: true });
          this.refs.AccountSubscriptionDialog.state.open = true;
          this.refs.AccountSubscriptionDialog.setState({ account_subscription_status: account_subscription_status });
          this.refs.AccountSubscriptionDialog.state.account_subscription_status = account_subscription_status;
          dialogCount += 1;
        }
      }
    }

    if(dialogCount > 0){
      this.setState({ dialogCount: dialogCount });
      this.state.dialogCount = dialogCount;
      return;
    }

    if (parseInt(res['has_read_tac']) < this.state.latestAgreementVersion) {
      this.showAgreement();
    }
    else {
      this.agreementAccepted();
    }
  }

  agreementCheck(){
    var dialogCount = this.state.dialogCount;
    if(dialogCount > 1){
      dialogCount -= 1;
      this.setState({ dialogCount: dialogCount });
      this.state.dialogCount = dialogCount;
      return;
    }
    if (this.state.has_read_tac < this.state.latestAgreementVersion) {
      this.showAgreement();
    }
    else {
      this.agreementAccepted();
    }
  }

  agreementAccepted() {
    this.props.root.loginOK(this.state.loginResult);
  }

  forgetPasswordClicked() {
    this.setState({forgetPasswordDialogOpen: true});
    this.state.forgetPasswordDialogOpen = true;
  }

  showAgreement() {
    this.setState({agreementDialogOpen: true});
    this.state.agreementDialogOpen = true;
  }

  render() {
    return (
      <div style={{position:"fixed", backgroundColor:grey[200], width:"100%", height:"100%", top:0, left:0, bottom:0, right:0}}>
        <LoginDialog root={this.props.root} parent={this} ref="loginDialog"/>
        <ForgetPasswordDialog parent={this} root={this.props.root} ref="forgetPasswordDialog"/>
        <AgreementDialog root={this.props.root} parent={this} ref="agreementDialog"/>
        <AccountDisabledDialog root={this.props.root} parent={this} ref="accountDisabledDialog"/>
        <AccountSubscriptionDialog root={this.props.root} parent={this} ref="AccountSubscriptionDialog"/>
      </div>
    )
  }
}

export default LoginPage;
